import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import {
    ACCOUNTS_WITH_SIGNALS_COLUMN,
    LIST_NAME_COLUMN,
} from "app/pages/sales-intelligence/pages/home/configuration/table-columns/columnNames";
import {
    NEW_ACCOUNTS_COLUMN,
    SAVED_SEARCHES_NAME_COLUMN,
} from "app/pages/sales-intelligence/pages/home/configuration/table-columns/saved-searches/columnNames";
import type { CellProps } from "app/pages/sales-intelligence/pages/home/types/table";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { CardEventCategory } from "../types";
import {
    getRedirectToAssetClickEventName,
    getRedirectToSignalsClickEventName,
    getRedirectToSignalsHoverEventName,
} from "../utils";

const createTableTrackingService = (track: TrackFn) => {
    const trackClickAction = (eventCategory: CardEventCategory, eventName: string): void => {
        track(`${eventCategory}`, "click", eventName);
    };

    const trackHoverAction = (eventCategory: CardEventCategory, eventName: string): void => {
        track(`${eventCategory}`, "hover", eventName);
    };

    return {
        trackRedirectToPageFromTableClicked<R>(eventCategory: CardEventCategory, { field, value }: CellProps<R>): void {
            switch (field) {
                case LIST_NAME_COLUMN:
                case SAVED_SEARCHES_NAME_COLUMN: {
                    const eventName = getRedirectToAssetClickEventName(eventCategory);

                    trackClickAction(eventCategory, createTrackingEventName(eventName, value));
                    break;
                }

                case ACCOUNTS_WITH_SIGNALS_COLUMN: {
                    const eventName = getRedirectToSignalsClickEventName(eventCategory);

                    trackClickAction(eventCategory, eventName);
                    break;
                }

                case NEW_ACCOUNTS_COLUMN: {
                    trackClickAction(eventCategory, "see new results");
                    break;
                }

                default:
                    trackClickAction(eventCategory, `unknown event name for column: ${field}`);
                    break;
            }
        },

        trackRedirectToPageFromTableHovered<R>(eventCategory: CardEventCategory, { field }: CellProps<R>): void {
            switch (field) {
                case ACCOUNTS_WITH_SIGNALS_COLUMN: {
                    const eventName = getRedirectToSignalsHoverEventName(eventCategory);

                    trackHoverAction(eventCategory, eventName);
                    break;
                }

                case NEW_ACCOUNTS_COLUMN: {
                    trackHoverAction(eventCategory, "interest in new results");
                    break;
                }

                default:
                    break;
            }
        },
    };
};

export default createTableTrackingService;
